import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild, AfterViewInit, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../../../utils/utils";
import { DefaultValuesService } from "../../../../services/defaultvalues.service";
import { PeYearlyPlanningListComponent, SearchItem } from "./pe-yearlyplanning-list.component";
import { MatDialog } from "@angular/material/dialog";
import { MatChipInputEvent } from "@angular/material/chips";
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { DialogService } from "../../../../services/dialog.service";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { CustomDialogService } from "../../../../services/customdialog.service";
import { ToastrService } from "ngx-toastr";
import { MatTabGroup } from "@angular/material/tabs";
import { FilterPopupComponent } from "../../shared-components/filterpopup/filterpopup.component";
import { TaxPeConfigurationService } from "../../../../services/tax-peconfiguration.service";
import { FiscalYearUtils } from "../../../../utils/fiscal-year.utils";

@Component({
    selector: "pe-yearlyplanning",
    templateUrl: './pe-yearlyplanning.component.html',
    styleUrls: ['../../../../style/container-tab-list.component.less', './pe-yearlyplanning.component.less', '../../../../style/new-generic-styles.component.less'],
    standalone: false
})

export class PeYearlyPlanningComponent implements OnInit, OnDestroy {

    @ViewChild('tabGroup') tabGroup!: MatTabGroup;
    @ViewChild(PeYearlyPlanningListComponent) peYearlyPlanningList: PeYearlyPlanningListComponent = {} as PeYearlyPlanningListComponent;

    isReleaseActive: boolean = false;
    releaseButtonText: string = 'Initiate Release';

    isRevokeActive: boolean = false;
    revokeButtonText: string = 'Initiate Revoke';

    title: string;
    waitHeader = '   -  **Please, wait until all breakdowns are properly loaded**';

    isEditModeEnabled = false;
    isExcelModeEnabled = false;
    isApprovalModeEnabled = false;
    isShowAllEnabled = true;

    subscriptionManagementId: any;
    subscriptionFiscalYear: any;
    subscriptions: any[] = [];

    list: TaxKpiManagement[] = [];
    selectedTabIndex = 0;

    // Filter section
    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    searchItems: SearchItem[] = [];

    filter = ''
    isAllLoaded = false;

    yearlyColumnsToDisplay = ['ItemNo', 'COL1', 'COL2', 'COL3', 'COL4', 'YTDACT', 'PYBUD', 'FYFC', 'FY1BUD', 'FY2BUD', 'FY3BUD', 'actions']

    showReleaseLabel = false;
    showPrereleaseLabel = false;
    isActive: boolean = false;
    disposalDate: Date | null = null;
    peConfigLoaded: boolean = false;

    constructor(
        public defaults: DefaultValuesService
        , private http: HttpClient
        , private dialogForm: MatDialog
        , private dialog: DialogService
        , public router: Router
        , @Inject('BASE_URL') private baseUrl: string
        , private datePipe: DatePipe
        , private customDialog: CustomDialogService
        , private toastrService: ToastrService
        , private changeDetector: ChangeDetectorRef
        , private readonly taxPeConfigurationService: TaxPeConfigurationService

    ) {
        this.title = `TAX - Yearly Operational Planning/Budget (${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear})`;
        this.dialog.tthis = this
    }

    ngOnInit() {
        
        this.subscriptionManagementId = this.defaults.managementIdMessageChanges$.subscribe(() => { 
            this.loadInformation(true);
            this.loadPeConfiguration();
        });
        this.subscriptionFiscalYear = this.defaults.fiscalYearMessageChanges$.subscribe(() => {
            this.loadInformation(true);
            this.loadPeConfiguration();
        });
        if (this.defaults.managementids.length !== 0) {
            this.loadInformation(true);
            this.loadPeConfiguration();
        }
    }

    ngOnDestroy() {
        this.subscriptionManagementId.unsubscribe();
        this.subscriptionFiscalYear.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    onClickExcelButton() {
        this.isExcelModeEnabled = true;
    }

    onClickCancelButton() {
        this.isEditModeEnabled = this.isExcelModeEnabled = false;
    }

    onClickEdit() {
        this.changeDetector.detectChanges();
        if (this.isEditModeEnabled === true) {
            this.isEditModeEnabled = false
            if (this.peYearlyPlanningList?.updatedItems?.length > 0) {
                this.loadInformation()
            }
        }
        else {
            this.isEditModeEnabled = true
        }
    }

    onClickShowAllButton() {
        if (this.isShowAllEnabled === false) {
            this.isShowAllEnabled = true
        }
        else {
            this.isShowAllEnabled = false
        }
    }

    onClickSave() {
        if (this.peYearlyPlanningList?.updatedItems.length === 0)
            this.isEditModeEnabled = false

        // Check for incorrect hours or units values
        if ((this.peYearlyPlanningList?.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'UNITS' || x.KpiUnit?.toUpperCase() === 'HOURS')
            && x.KpiValue.indexOf('.00') < 0).length > 0)) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect value provided with decimals for a Units or Hours KPI.' } });
            return;
        }
        // Check for incorrect decimal value
        if ((this.peYearlyPlanningList?.updatedItems.filter(x =>
            x.KpiUnit?.toUpperCase() === 'DECIMAL'
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0)) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect decimal value provided' } });
            return;
        }
        // Check for incorrect currency values based on local currency
        if ((this.peYearlyPlanningList?.updatedItems.filter(x =>
            (x.KpiUnit?.toUpperCase() === 'VALUES' || x.KpiUnit?.toUpperCase() === 'VALUE LC')
            && this.isCorrectCurrencyValue(x.KpiValue, x.DecimalDigits) === false).length > 0)) {
            this.dialog.showErrorDialog({ 'error': { 'message': 'Incorrect currency value provided.' } });
            return;
        }
        //Yearly
        if (this.peYearlyPlanningList?.updatedItems.length > 0) {
            Utils.httpUpdateTaxKpisYearlyPlanning(
                this.http,
                this.baseUrl,
                this.peYearlyPlanningList?.updatedItems,
                this,
                function (tthis: PeYearlyPlanningComponent) {
                    const kpisWithoutForecast = tthis.peYearlyPlanningList?.updatedItems?.filter(x => x.IsAccumulative === true && x.Field === 'FY1BUD' && !x.auxFYFC)
                    if (kpisWithoutForecast.length > 0)
                        tthis.dialog.showSuccessDialog(kpisWithoutForecast.map((object) => object.AccountId).join('; '),
                            'Following accumulative Accounts did not include a forecast for current fiscal year. Consequently, automatic monthly splitting may not be accurate',
                            [])
                    tthis.loadInformation()
                    tthis.isEditModeEnabled = false
                    tthis.toastrService.success('Kpi values were updated successfully!');
                },
                function (tthis: PeYearlyPlanningComponent, error: string) {
                    tthis.dialog.showErrorDialog(error);
                }
            );
            const url = this.baseUrl + "api/KPIManagement/setopl/BUDY";
            this.http.post<any[]>(url, this.peYearlyPlanningList.updatedItems).subscribe(() => {
                


            }, error => {
                Utils.writeLog(this.http, this.baseUrl, error);
            });
        }
    }

    onClickReleaseMode() {
        var selectedRows = this.peYearlyPlanningList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Release Kpi values",
            message: `Do you want to release all current values for next fiscal year with selected parameters? Please note that you cannot edit any values after the release!.`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpReleaseTaxKpiDefinitions(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , false
                    , this
                    , function (tthis: PeYearlyPlanningComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were released successfully!');
                        tthis.toggleRelease();
                    }
                );
            }
        })
    }

    onClickRevoke(oplyearly: boolean) {
        var selectedRows = this.peYearlyPlanningList?.getSelectionList();
        if (!selectedRows)
            selectedRows = []
        this.customDialog.openConfirm({
            title: "Revoke KPI values",
            message: `Do you want to revoke all populated values for selected period?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed === true) {
                Utils.httpRevokeTaxKpiValues(
                    this.http
                    , this.baseUrl
                    , selectedRows
                    , false
                    , this
                    , function (tthis: PeYearlyPlanningComponent) {
                        tthis.loadInformation();
                        tthis.toastrService.success('Kpi values were revoked successfully!');
                        tthis.toggleRevoke();

                    }
                );
            }
        })
    }

    isCorrectCurrencyValue(value: string, decimalDigits: number) {
        const dotIndex = value.indexOf('.');
        const colonIndex = value.indexOf(',');
        if (dotIndex === -1 && colonIndex === -1) {
            return true;
        }

        const maxSymbol = Math.max(dotIndex, colonIndex);
        if (maxSymbol === -1 || maxSymbol === value.length - 1) {
            return true;
        }
        return value.length - maxSymbol - 1 <= decimalDigits;
    }

    downloadExcelInformation() {
        let date = new Date()
        const year = date.getFullYear().toString(); // a�o
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // mes con dos d�gitos
        const day = date.getDate().toString().padStart(2, '0'); // d�a con dos d�gitos

        Utils.httpDownloadYearlyOPLTaxInformation(
            this.http
            , this.baseUrl
            , `${year}${month}${day}_${this.defaults.managementid}_${this.defaults.groupFunction}_${this.defaults.fiscalYear - 1}-${this.defaults.fiscalYear}_TAX_BUD_Y`
            , this.isShowAllEnabled
            , this
            , function (tthis: PeYearlyPlanningComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
            });
    }

    goUploadFileView() {
        this.router.navigate(["file/" + Utils.getFileUploadTaxOplYearlyInformation()]);
    }

    // Filter section

    auxFilterPredicate(filters: string, data: any, parentLevel: boolean, showAllEnabled: boolean): boolean {
        if (filters === '__FORCE__') {
            return parentLevel || showAllEnabled || !!(data.FY1BUD || data.FY2BUD || data.FY3BUD || data.YTDACT || data.PYBUD || data.FYFC);
        }
        const filterArray = filters.split('+').filter(x => x);
        return filterArray.every(filter => {
            if (parentLevel) {
                const kpiname = (data.KpiName || '').toLowerCase();
                const id = (data.AccountID || '').toLowerCase();
                return kpiname.includes(filter.toLowerCase()) || id.includes(filter.toLowerCase());
            } else {
                const granularity = (data.Granularity || '').toLowerCase();
                let result = granularity.includes(filter.toLowerCase());
                if (!showAllEnabled) {
                    result = result && !!(data.FY1BUD || data.FY2BUD || data.FY3BUD || data.YTDACT || data.PYBUD || data.FYFC);
                }
                return result;
            }
        });
    }


    public toggleRelease() {
        this.isReleaseActive = !this.isReleaseActive;
        this.releaseButtonText = this.isReleaseActive ? 'Abort Release' : 'Initiate Release', this.peYearlyPlanningList.clearSelectionList()
    }

    public toggleRevoke() {
        this.isRevokeActive = !this.isRevokeActive;
        this.revokeButtonText = this.isRevokeActive ? 'Abort Revoke' : 'Initiate Revoke', this.peYearlyPlanningList.clearSelectionList()
    }

    canUserRevoke() {
      return this.defaults.isMersyCDPTaxAdmin
        || this.defaults.isMersyCDPTaxRevoker
    }

    canUserRelease() {
      return this.canUserRevoke()
        || this.defaults.isMersyCDPTaxReporter
    }

    private loadInformation(canShowReleaseMenssage: boolean = false) {
        this.subscriptions.forEach(x => x.unsubscribe())
        this.showReleaseLabel = false;
        this.showPrereleaseLabel = false;
        this.isAllLoaded = false
        this.title = `TAX - Yearly Operational Planning/Budget (${this.defaults.managementName} - ${this.defaults.fiscalYear - 1}/${this.defaults.fiscalYear})`;
        let showMandatoryReleaseMessage = canShowReleaseMenssage && this.defaults.userCanReleaseMersy();

        Utils.httpGetTaxYearlyPlanningInformation(
            this.http
            , this.baseUrl
            , this
            , function (tthis: PeYearlyPlanningComponent, result: TaxKpiManagement[]) {
                setTimeout(() => {
                    result.forEach(x => {
                        const row = x.KpiDetail[0]
                        let maxBreakdown = ''
                        let yearlyColumns = Object.assign([], tthis.yearlyColumnsToDisplay);

                        if (row.COL4 === '') {
                            yearlyColumns.splice(yearlyColumns.indexOf('COL4'), 1)
                            maxBreakdown = 'COL3'
                        }
                        if (row.COL3 === '') {
                            yearlyColumns.splice(yearlyColumns.indexOf('COL3'), 1)
                            maxBreakdown = 'COL2'
                        }
                        if (row.COL2 === '') {
                            yearlyColumns.splice(yearlyColumns.indexOf('COL2'), 1)
                            maxBreakdown = 'COL1'
                        }
                        if (row.COL1 === '') {
                            yearlyColumns.splice(yearlyColumns.indexOf('COL1'), 1)
                            maxBreakdown = 'COL0'
                        }
                        x.yearlyColumns = yearlyColumns
                        x.maxBreakdown = maxBreakdown
                        tthis.showReleaseLabel = tthis.showReleaseLabel || x.KpiDetail.filter(x => x.ApprovalStatus === 'RELEASED' ||
                            x.ApprovalStatus_FY2 === 'RELEASED' ||
                            x.ApprovalStatus_FY3 === 'RELEASED').length > 0
                        tthis.showPrereleaseLabel = tthis.showPrereleaseLabel || x.KpiDetail.filter(x => x.ApprovalStatus === 'PRE-RELEASED' ||
                            x.ApprovalStatus_FY2 === 'PRE-RELEASED' ||
                            x.ApprovalStatus_FY3 === 'PRE-RELEASED').length > 0
                    });

                    tthis.list = [];
                    tthis.list = result
                    tthis.isAllLoaded = true;
                    if (showMandatoryReleaseMessage) {
                        tthis.dialog.doBack = false;
                        tthis.dialog.messageFontSize = 22;
                        tthis.dialog.extraClasses = ['height_38vh', 'width_35vw', 'light-background'];
                        tthis.dialog.showSuccessDialog('Please be aware that the release of data is mandatory');
                    }
                }, 50)
            }
            , function (tthis: PeYearlyPlanningComponent, error: string) {
                tthis.dialog.showErrorDialog(error);
                tthis.list = [];
            }
        );
    }

    private loadPeConfiguration(): void {
        this.taxPeConfigurationService.getPeConfiguration(
            this,
            (tthis: PeYearlyPlanningComponent, result: PeConfiguration) => {
                tthis.isActive = result.active;
                tthis.disposalDate = result.disposalDate ? new Date(result.disposalDate) : null;
                tthis.peConfigLoaded = true;
            },
            (tthis: PeYearlyPlanningComponent, error: any) => {
                console.warn("Unable to load PE Configuration, defaulting to active", error);
                tthis.isActive = true;
                tthis.disposalDate = null;
                tthis.peConfigLoaded = true;
            }
        );
    }

    public isEditingAllowed(): boolean {
        if (!this.isActive) return false;
        if (!this.disposalDate) return true;

        const selectedFiscalYear = this.defaults.fiscalYear;
        const disposalFiscalYear = FiscalYearUtils.getFiscalYearFromDate(this.disposalDate);
        
        return disposalFiscalYear > selectedFiscalYear;
    }
}